import isEqual from "lodash/isEqual";

import {getFeatureIsActive, getFeatureParent, getSkuWithoutDot, isInStock} from "./lookFunctions2";
import {LOOK_NAVIGATION_LIST_TYPES, LOOK_WALLS_ONLY, METADATA} from "../core/constants";
import {getCurrentLayout} from "../../appLayout";
import {getFeatureCost, getFeatureIsLocked, isIframe} from "../../../misc/helpers";
import store from "../../../store";
import {getFilterGroupValue, getFilterGroupValues} from "../../../misc/utils";
import {getFeatureOptions} from "./lookFunctions";
import {Vanity} from "../core/parts/vanity";
import {setLookWallsApplyTo} from "../../../actions/lookFunctions";
import {CABINET_GROUP, COUNTERTOP_GROUP, EDGE_GROUP} from "../../kvComponent/core/constants";
import {
  setCabinetsApplyTo, setCabinetsApplyToBathroom,
  setCountertopsApplyTo,
  setCountertopsApplyToBathroom, setEdgesApplyTo, setApplyToCommon
} from "../../../actions/navigationFunctions";
import CountertopSwitchers from "../../kvComponent/navigation/countertopSwitchers";
import CabinetSwitchers from "../../kvComponent/navigation/cabinetSwitchers";
import Config, {getCommonVisualizerType, IS_LIXIL_UI, IS_PRODUCT_JOURNEY} from "../../../config";
import {
  CABINET_GROUP_BATHROOM,
  COUNTERTOP_GROUP_BATHROOM,
  HANDLES_GROUP_BATHROOM, SHOWER_FLOOR_GROUP_BATHROOM
} from "../../bvSceneComponent/core/constants";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import {updateCanvasCount} from "../../../actions/actionFunctions";
import {getBvGroupFeatures} from "../../../api/server-api";
import {getAdditionalFeaturesOnScroll} from "../../../api/look-api";
import {setMaterialsCanvasLoading} from "../../../actions/selectionFunctions";

const getFeaturePropertyToSort = (navItem, property) => {
  if (property === "name") {
    return navItem.part.getFeatureName()
  }
  if (property === "SortPositionNum") {
    return navItem.part.metaData[property] || 99999;
  }
  return navItem.part[property];
}

const getNavItemsSortedByProperty = (navItems, property, property2) => {
  const order = "asc";
  // console.log("navItems - navItems", navItems);
  navItems = navItems.sort((a,b) => {
    let prop1 = getFeaturePropertyToSort(a, property);
    let prop2 = getFeaturePropertyToSort(b, property);
    let prop3 = getFeaturePropertyToSort(a, property2);
    let prop4 = getFeaturePropertyToSort(b, property2);
    return order === "asc"
      ? (prop1 > prop2) ? 1 : (prop1 < prop2) ? -1 : (prop3 > prop4) ? 1 : (prop3 < prop4) ? -1 : 0
      : (prop1 < prop2) ? 1 : (prop1 > prop2) ? -1 : (prop3 < prop4) ? 1 : (prop3 > prop4) ? -1 : 0
  })
  // console.log("navItems", navItems);
  return navItems
};

/**
 * sorts navItems
 * @param navItems {[object]}
 * @param isQuotingTool {boolean}
 * @param lookViewType {number}
 * @returns {[object]}
 */
export const getSortedNavItems = (navItems, isQuotingTool = false, lookViewType = 0) => {
  const {fabricatorState, userState, shopState} = store.getState();
  if (IS_LIXIL_UI && !shopState.shopPageOpened) {
    isQuotingTool = true;
  }
  const {isPhoneNumberValidated} = userState;
  const fabricatorSettings = fabricatorState.settings;

  if ((fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) && !isPhoneNumberValidated) {
    const unLockedFeatures = navItems
      .filter(navItem => !getFeatureIsLocked(navItem.part))
      .map(navItem => {
        navItem.part.featurePrice = getFeatureCost(navItem.part, 1);
        return navItem
      })
    const lockedFeatures = navItems
      .filter(navItem => getFeatureIsLocked(navItem.part))
      .map(navItem => {
        navItem.part.featurePrice = getFeatureCost(navItem.part, 1);
        return navItem
      })
    navItems = fabricatorSettings.showPricing ? [
      ...getNavItemsSortedByProperty(unLockedFeatures, "featurePrice", "name"),
      ...getNavItemsSortedByProperty(lockedFeatures, "featurePrice", "name")
    ] : [...unLockedFeatures, ...lockedFeatures];
  } else if (navItems[0] && navItems[0].part.partId === "crown_molding" && navItems[0].part.getParent().sortNavigationItems) {
    navItems = navItems[0].part.getParent().sortNavigationItems(navItems);
  } else if (fabricatorSettings.showPricing && !fabricatorState.hideCheckoutBreakdownCost && !fabricatorState.hidePricesFromUser) {
    navItems = navItems.map(navItem => {
      navItem.part.featurePrice = getFeatureCost(navItem.part, 1);
      return navItem
    })
    navItems = getNavItemsSortedByProperty(navItems, "featurePrice", "name")
  } else {
    const propertyToSort = navItems.some(navItem => navItem.part.metaData["SortPositionNum"]) ? "SortPositionNum" : "name";
    navItems = getNavItemsSortedByProperty(navItems, propertyToSort, "");
    navItems = navItems.sort((a, b) => isInStock(b.part) - isInStock(a.part));
    if (!isQuotingTool && navItems.some(navItem => navItem.part.useMatchesFailedNavigation)) {
      navItems = getNavItemsSortedByProperty(navItems, "matchesMetaFailed");
    }
  }
  if (isQuotingTool) {
    // navItems = getNavItemsSortedByProperty(navItems, "notAvailableInVisualizer", "_customDisplayName")
    const inVisFeatures = navItems.filter(navFeature => !navFeature.part.notAvailableInVisualizer);
    const notInVisFeatures = navItems.filter(navFeature => navFeature.part.notAvailableInVisualizer);
    const separator = IS_PRODUCT_JOURNEY && inVisFeatures.length && notInVisFeatures.length && (lookViewType === 1)
      ? [{notInVisSeparator: true}] : [];
    navItems = [
      ...inVisFeatures,
      ...separator,
      // ...getNavItemsSortedByProperty(notInVisFeatures, "featurePrice", "name")
      ...notInVisFeatures
    ];
  }
  return navItems
};

const updateNavItemsToChange = (navItemsToChange, navItems, stoneFeatures) => {
  stoneFeatures.forEach(cartItem => { // yes, the getStonesActiveFeatures method returns cat item objects for some reason :facepalm:
    if (cartItem && cartItem.cartFeature) {
      const stoneName = cartItem.cartFeature.getSplittedFeatureName();
      if (!navItemsToChange.some(navItem => navItem.part.getSplittedFeatureName() === stoneName)) {
        const existingInNavItems = navItems.find(navItem => {
          if (!navItem || navItem.notInVisSeparator) {
            return false
          }
          return navItem.part.getSplittedFeatureName() === stoneName
        });
        if (existingInNavItems) {
          navItemsToChange.unshift(existingInNavItems) // push to beginning
        }
      }
    }
  });
  return navItemsToChange
}

/**
 * reorder features, places selected and similar walls on the beginning
 * @param navItems {[object]}
 * @param lookActiveFeature {featureInterface}
 * @param lookActiveCategory {string}
 * @param featureGroup {featureGroupInterface}
 * @param isQuotingTool {boolean}
 * @param needToReplaceActiveFeature {boolean}
 * @param lookViewType {number}
 * @returns {[object]}
 */
export const getReorderedItems = (
  navItems,
  lookActiveFeature,
  lookActiveCategory,
  featureGroup,
  isQuotingTool,
  needToReplaceActiveFeature = true,
  lookViewType = 0,
) => {

  navItems = navItems.filter(feature => feature)//todo not sure why, but we in some cases have [undefined, item, item, item, undefined, undefined] etc... //need to fix this

  // let activeNavItem, activeNavItemIndex;
  const parentFeatureGroup = featureGroup || getFeatureParent(lookActiveFeature, lookActiveCategory);
  if (!parentFeatureGroup) {
    return navItems
  }
  let navItemsToChange = [];
  if (needToReplaceActiveFeature) {
    const activeNavItem = navItems.find(navItem => {
      if (!navItem || navItem.notInVisSeparator) {
        return false
      }
      return getFeatureIsActive(navItem.part, lookActiveFeature, lookActiveCategory, featureGroup)
    })
    if (activeNavItem) {
      navItemsToChange.push(activeNavItem);
    }
  }
  const isWalls = LOOK_WALLS_ONLY.includes(parentFeatureGroup.partId);
  if (isWalls) {
    const layout = getCurrentLayout();
    const stoneFeatures = layout.getStonesActiveFeatures();
    navItemsToChange = updateNavItemsToChange(navItemsToChange, navItems, stoneFeatures);
    // console.log("stoneFeatures", stoneFeatures);
  }
  const isCabinet = CABINET_GROUP.includes(parentFeatureGroup.partId);
  if (isCabinet) {
    const layout = getCurrentLayout();
    const cabinetFeatures = layout.getActiveFeatures(true).filter(activeFeature => {
      return activeFeature && CABINET_GROUP.includes(activeFeature.partId)
    })
    // console.log("stoneFeatures", stoneFeatures);
    navItemsToChange = updateNavItemsToChange(navItemsToChange, navItems, cabinetFeatures);
  }
  // console.log("navItemsToChange", navItemsToChange);
  const sorted = getSortedNavItems(navItems, isQuotingTool, lookViewType);
  navItemsToChange.forEach((nItemToChange) => {
    const currentIndex = sorted.findIndex(navItem => {
      if (!navItem || navItem.notInVisSeparator) {
        return false
      }
      return navItem.part.dbFeature.id === nItemToChange.part.dbFeature.id
    })
    if (currentIndex > -1) {
      sorted.splice(currentIndex, 1);
      sorted.splice(0, 0, nItemToChange);
    }
  });
  // console.log("sorted", sorted);
  return sorted
};

/**
 * Checks if list feature is currently active
 * @param navItems {[navItemInterface]}
 // * @param filterGroups {[filterGroupInterface]}
 * @returns {[navItemInterface]}
 */
export const getReplacedNavItemsWithUnlockedFeatures = (navItems) => {
  const {pricingLocked} = pricingIsLocked();
  if (!pricingLocked) {
    return navItems
  }

  return navItems.map(navItem => {
    if (!getFeatureIsLocked(navItem.part)) {
      return navItem
    }
    // const colorOptions = getFeatureOptions(navItem.part, filterGroups); // removed to optimize running getNavItems function multiple times
    // if needed - we can pass navItems to this function
    if (!navItem.colorOptions) {
      return navItem
    }
    const unlockedOption = navItem.colorOptions.find(option => {
      if (!option.feature) {
        return false
      }
      if (option.feature.dbFeature.id === navItem.part.dbFeature.id) {
        return false
      }
      return !getFeatureIsLocked(option.feature)
    })
    if (unlockedOption && !navItems.some(nItem => nItem.part.dbFeature.id === navItem.part.dbFeature.id)) {
      return {part: unlockedOption.feature}
    }
    return navItem
  })
}

/**
 * Checks if list feature is currently active
 * @param navItems {[navItemInterface]}
 * @returns {array}
 */
export const getDesignRecommendedNavItems = (navItems) => {

  const {filterState, bathroomVisualizerState} = store.getState();
  const {filterGroups} = filterState;
  const {activePreset} = bathroomVisualizerState;

  const desRecFilterGroup = filterGroups.find(group => group.name === "Designer Recommended");

  if (!desRecFilterGroup) {
    return []
  }

  return navItems.filter(navItem => {
    // if (navItem.part.dbFeature.sharedFeatureName === "23486BEA") {
    //   debugger;//eslint-disable-line
    // }
    if (navItem.notInVisSeparator) {
      return null
    }
    const desRecFeature = getFilterGroupValues(navItem.part, desRecFilterGroup);
    const desRecColorFeatures = getFeatureOptions(navItem.part, filterGroups, false, navItem.colorOptions || []);
    const desRecValues = [
      ...(desRecFeature || []),
      ...(desRecColorFeatures || []).map(colorOption => {
        return getFilterGroupValues(colorOption.feature, desRecFilterGroup)
      })
    ];
    return desRecValues && desRecValues.some(desRecValue => {
      if (Array.isArray(desRecValue)) {
        return desRecValue.some(filterId => {
          const filterValueObject = getFilterGroupValue(filterId, desRecFilterGroup);
          return filterValueObject && (+filterValueObject.value === activePreset)
        })
      }
      const filterValueObject = getFilterGroupValue(desRecValue, desRecFilterGroup);
      return filterValueObject && (+filterValueObject.value === activePreset)
    })
  });
}

/**
 * reorder features, places selected and similar walls on the beginning
 * @param navItems {[navItemInterface]}
 * @param lookActiveFeature {featureInterface}
 * @returns {[navItemsListInterface]}
 */
export const getNavigationItemsLists = (navItems, lookActiveFeature) => {

  if (!navItems.length) {
    return [{
      type: LOOK_NAVIGATION_LIST_TYPES.regular,
      navItems: [],
    }]
  }

  let navItemsList = [];

  const designRecommended = getDesignRecommendedNavItems(navItems);
  if (designRecommended.length) {
    navItemsList.push({
      type: LOOK_NAVIGATION_LIST_TYPES.designRec,
      navItems: getSortedNavItems(designRecommended),
    })
  }

  const others = designRecommended.length ? navItems.filter(navItem => {
    return designRecommended.every(designNavItem => designNavItem.part.dbFeature.id !== navItem.part.dbFeature.id)
  }) : navItems;

  if (!navItems[0]) { // some unexpected case
    return navItemsList
  }

  const featureGroup = navItems[0].part.getParent();

  switch (featureGroup.partId) {
    case "vanity_faucet": {
      if (IS_PRODUCT_JOURNEY) {
        navItemsList.push({
          type: LOOK_NAVIGATION_LIST_TYPES.regular,
          navItems: others,
        });
        break;
      }
      const regularFeatures = {
        type: LOOK_NAVIGATION_LIST_TYPES.regular,
        navItems: [],
      };
      const vanityParent = featureGroup.getParent();
      const sinkParent = vanityParent.sink;

      others.forEach(navItem => {
        if (!sinkParent || !sinkParent.activeFeature || !navItem.part.metaData.MountHoles
          || (lookActiveFeature && isEqual(navItem.part.metaData.MountHoles, lookActiveFeature.metaData.MountHoles))) {
          if (!regularFeatures.navTranslate && navItem.part.metaData.MountHoles) {
            regularFeatures.navTranslate = "look.features.other.faucet." + navItem.part.metaData.MountHoles[0]
          }
          regularFeatures.navItems.push(navItem);
        } else if (navItem.part.metaData.MountHoles) {
          const existingNonMatchingList = navItemsList.find(navItemsObject => {
            return navItemsObject.type === LOOK_NAVIGATION_LIST_TYPES.notMatchingMeta && navItemsObject.notMatchingMetaName === navItem.part.metaData.MountHoles[0];
          });
          if (existingNonMatchingList) {
            existingNonMatchingList.navItems.push(navItem)
          } else {
            navItemsList.push({
              type: LOOK_NAVIGATION_LIST_TYPES.notMatchingMeta,
              notMatchingMetaName: navItem.part.metaData.MountHoles[0],
              navItems: [navItem],
              navTranslate: "look.features.other.faucet." + navItem.part.metaData.MountHoles[0]
            });
          }
        }
      })
      navItemsList.push(regularFeatures);
      break;
    }
    default: {
      navItemsList.push({
        type: LOOK_NAVIGATION_LIST_TYPES.regular,
        navItems: others,
      });
      break;
    }
  }

  return navItemsList
};

const getSinksWidth = (nextSink) => {
  let maxWidth = 0;
  let maxTotalWidth = 0;
  if (nextSink.metaData["MatchingFeature"].includes(METADATA.NO)) {
    const parent = nextSink.getParent();
    Object.keys(parent.layerPositions).forEach(position => {
      const positionFeature = parent.layerPositions[position];
      if (positionFeature && positionFeature.metaData["SinkWidth"]) {
        maxTotalWidth += positionFeature.metaData["SinkWidth"];
      }
    });
    if (nextSink.metaData["SinkWidth"]) {
      maxWidth = nextSink.metaData["SinkWidth"]
    }
  }
  // console.log("maxWidth", maxWidth, maxTotalWidth);
  return {maxWidth, maxTotalWidth}
}

export const findNextVanityTypeFeature = (nextSink, nextFeatureGroup) => {
  if (!nextSink.metaData["MatchingFeature"] || nextSink.notAvailableInVisualizer) {
    return null
  }
  const nextSinkSku = getSkuWithoutDot(nextSink.dbFeature.sharedFeatureName);
  if (nextFeatureGroup && nextFeatureGroup.activeFeature
    && nextSink.metaData["MatchingFeature"].includes(getSkuWithoutDot(nextFeatureGroup.activeFeature.dbFeature.sharedFeatureName))) { // it is already matching! return it
    // cases when vanity MatchingFeature - ['0328001', '0328004', '0328008'] and sink - '0329008'
    if (!nextFeatureGroup.activeFeature.metaData["MatchingFeature"]
        || (nextFeatureGroup.activeFeature.metaData["MatchingFeature"]
            && nextFeatureGroup.activeFeature.metaData["MatchingFeature"].includes(nextSinkSku))) {
      return nextFeatureGroup.activeFeature
    }
  }

  const isQCSink = nextSink.metaData["MatchingFeature"].includes(METADATA.NO);
  const {maxWidth, maxTotalWidth} = getSinksWidth(nextSink);

  const allVanities = [...nextFeatureGroup.features, ...nextFeatureGroup.featuresParts];
  let matchingVanities = allVanities.filter(testFeature => {
    if (testFeature.notAvailableInVisualizer) {
      return false
    }
    if (!testFeature.metaData["MatchingFeature"]) {
      return false
    }
    if (isQCSink) {
      if (!testFeature.metaData["MatchingFeature"].includes(METADATA.NO)) {
        return false
      }
      if (!testFeature.metaData["VanityWidth"]) {
        return true // just in case
      }
      if (nextSink.isSinkWithCountertopIncluded()) {
        return nextSink.metaData["VanityWidth"] === 24 && (nextSink.metaData["layerPosition"] !== "C")
          ? testFeature.metaData["VanityWidth"] === 64 // they can work with L or R sides, only big ones
          : testFeature.metaData["VanityWidth"] === nextSink.metaData["VanityWidth"]
      }
      if (nextSink.metaData.layerPosition !== "C") { // L or R should be only on double vanity or two separate
        return testFeature.metaData["VanityWidth"] === 64
          || (testFeature.metaData["VanityWidth"] === 24 && testFeature.metaData["VanityWidth"] > maxWidth
            && (testFeature.metaData["layerPosition"] !== "C"))
      }
      if (!maxWidth) {
        return true
      }
      return testFeature.metaData["VanityWidth"] > maxWidth
    }
    return nextSink.metaData["MatchingFeature"].includes(getSkuWithoutDot(testFeature.dbFeature.sharedFeatureName))
      && testFeature.metaData["MatchingFeature"].includes(nextSinkSku)
  });
  // console.log("matchingVanities", matchingVanities);
  if (matchingVanities.length > 1 && nextFeatureGroup.activeFeature) {
    // console.log("matchingVanities", matchingVanities);
    const currentActiveFeature = matchingVanities.find(feature => feature.dbFeature.id === nextFeatureGroup.activeFeature.dbFeature.id);
    if (currentActiveFeature) {
      return currentActiveFeature
    }
    const currentSkuFeature = matchingVanities.find(feature => feature.dbFeature.sharedFeatureName === nextFeatureGroup.activeFeature.dbFeature.sharedFeatureName);
    if (currentSkuFeature) {
      return currentSkuFeature // to test
    }
    let currentSideFeatures = matchingVanities.filter(feature => isEqual(feature.metaData["Side"], nextSink.metaData["Side"]));
    if (!currentSideFeatures.length) {
      currentSideFeatures = matchingVanities.filter(feature => isEqual(feature.metaData["Side"], nextFeatureGroup.activeFeature.metaData["Side"]));
    }
    if (isQCSink && !currentSideFeatures.length && nextSink.metaData["Side"]) {
      if (nextSink.metaData["Side"][0] === "C") {
        console.log("NO VANITY FEATURES WITH C METADATA FOUND", );
      } else if (maxTotalWidth) {
        currentSideFeatures = matchingVanities.filter(feature => {
          return feature.metaData["VanityWidth"] && feature.metaData["VanityWidth"] > maxTotalWidth
        });
        console.log("currentSideFeatures", currentSideFeatures);
      }
    }
    const sameColors = currentSideFeatures.filter(feature => feature.getColorName() === nextFeatureGroup.activeFeature.getColorName());
    return sameColors[0] || currentSideFeatures[0] || matchingVanities[0]
  }
  return matchingVanities[0];
}

const updateNonCompatibleListWithVanity = (nextSink, nonCompatibleList = []) => {
  const layout = getCurrentLayout();
  const vanityParent = layout.parts[Vanity.id];
  const currentVanityTypeFeatureGroup = vanityParent.relatedItems.find(relItem => relItem.partId === vanityParent.vanity_type);

  if (nextSink.metaData["CustomVanityType"] && nextSink.metaData["CustomVanityType"].includes(vanityParent.vanity_type)) {
    // for example currently we have Studio S vanity Cabinet, but it will be changed to Townsend
    if (currentVanityTypeFeatureGroup
      && currentVanityTypeFeatureGroup.activeFeature
      && nextSink.metaData["MatchingFeature"]
      && (!nextSink.metaData["MatchingFeature"].includes(METADATA.NO)
        && currentVanityTypeFeatureGroup.activeFeature.metaData["MatchingFeature"]
        && currentVanityTypeFeatureGroup.activeFeature.metaData["MatchingFeature"].includes(METADATA.NO))
      && !nextSink.metaData["MatchingFeature"].includes(getSkuWithoutDot(currentVanityTypeFeatureGroup.activeFeature.dbFeature.sharedFeatureName))) {
      const nextVanity = findNextVanityTypeFeature(nextSink, currentVanityTypeFeatureGroup)
      // console.log("nextVanity", nextVanity);
      if (nextVanity && currentVanityTypeFeatureGroup.activeFeature.dbFeature.id !== nextVanity.dbFeature.id) {
        nonCompatibleList.push({
          from: currentVanityTypeFeatureGroup.activeFeature,
          to: nextVanity,
        })
      }
    }
  } else {
    // console.log("next sink is not compatible, pls check");
    if (nextSink.metaData["MountType"].includes("ST")) {
      if (!nonCompatibleList.some(fromToObject => fromToObject.to && fromToObject.to.dbFeature.id === nextSink.dbFeature.id)) {
        nonCompatibleList.push({
          from: currentVanityTypeFeatureGroup ? currentVanityTypeFeatureGroup.activeFeature : nextSink.getParent().activeFeature,
          to: nextSink,
        })
      }
    } else if (nextSink.metaData["CustomVanityType"]) {
      const nextFeatureGroup = vanityParent.relatedItems.find(relItem => relItem.partId === nextSink.metaData["CustomVanityType"][0]);
      if (nextFeatureGroup) {
        const nextVanity = findNextVanityTypeFeature(nextSink, nextFeatureGroup)
        // console.log("nextVanity", nextVanity);
        const fromFeature = currentVanityTypeFeatureGroup
          ? currentVanityTypeFeatureGroup.activeFeature
          : nextSink.getParent().activeFeature; // if no vanity_type - it means that standalone sink is selected
        if (nextVanity) {
          nonCompatibleList.push({
            from: fromFeature,
            to: nextVanity,
          })
        }
      }
    }
  }
  return nonCompatibleList
}

/**
 * * when clicked on feature - search for same MountHoles sink (to keep selected faucet)
 * @param feature {featureInterface}
 * @returns {featureInterface}
 */
export const getNextSinkOnWashstandOrConsoleChange = (feature) => {
  const layout = getCurrentLayout();
  const vanityParent = layout.parts[Vanity.id];
  const sinkParent = vanityParent.sink;
  const isQcSink = sinkParent && sinkParent.activeFeature && sinkParent.activeFeature.metaData["MatchingFeature"].includes(METADATA.NO)
  const isFormicaSinks = sinkParent.activeFeature?.isSinkWithCountertopIncluded();
  const forSinkConditions = [{
    propName: "MatchingFeature",
    propValue: isQcSink ? METADATA.NO : getSkuWithoutDot(feature.dbFeature.sharedFeatureName)
  }, {
    propName: "FeatureSku",
    propValue: isQcSink ? METADATA.NO : feature.metaData["MatchingFeature"]
  }];
  if (isQcSink && feature.metaData["VanityWidth"]) {
    // QC sink, we should check width
    forSinkConditions.push({
      propName: isFormicaSinks ? "VanityWidth" : "SinkWidth",
      propValue: feature.metaData["VanityWidth"],
      // propData: {
      //   layerPosition: feature.metaData.layerPosition
      // }
    })
  }
  if (sinkParent && sinkParent.activeFeature && !sinkParent.activeFeature.matchesMetaForArrayOfConditions(forSinkConditions)) {
    const layout = getCurrentLayout();
    const navItems = layout.designNavigationItems({part: sinkParent}, [], "", sinkParent.activeFeature);
    const nextAvailableSinks = navItems.filter(navItem => navItem.part.matchesMetaForArrayOfConditions(forSinkConditions));
    const conditionsToMatch = [{
      propName: "MountHoles",
      propValue: sinkParent.activeFeature.metaData["MountHoles"]
    }];
    return nextAvailableSinks.length
      ? nextAvailableSinks.find(navItem => navItem.part.matchesMetaForArrayOfConditions(conditionsToMatch)) || nextAvailableSinks[0]
      : null;
  }
  return null
}

/**
 * when clicked on washstand or console - search for the same MountHoles sink (to keep selected faucet)
 * @param feature {featureInterface}
 */
export const updateSinkWithNewFeature = (feature) => {
  const layout = getCurrentLayout();
  const vanityParent = layout.parts[Vanity.id];
  const sinkParent = vanityParent.sink;

  if (sinkParent && sinkParent.activeFeature) {
    const nextSink = getNextSinkOnWashstandOrConsoleChange(feature);
    if (nextSink) {
      const sinkFeature = nextSink.part;
      if (sinkParent.layerPositions && nextSink.part.metaData.layerPosition) {
        Object.keys(sinkParent.layerPositions).forEach(position => {
          if (position === sinkFeature.metaData.layerPosition) {
            sinkParent.layerPositions[position] = sinkFeature
          } else if (sinkParent.layerPositions[position]) { // only replace existing
            const sameFeature = sinkParent.getMatchingPositionFeature(position, sinkFeature);
            sinkParent.layerPositions[position] = sameFeature || null; // if no feature found - erase previous
          }
        })
      }
      sinkParent.activeFeature = sinkFeature;
    }
  }
}

/**
 * checks if feature needs a compatability alert
 * @param feature {featureInterface}
 * @returns {array}
 */
export const checkForCompatabilityAlert = (feature) => {
  if (feature.notAvailableInVisualizer) {
    return []
  }
  if (document.kvConfig.visualizerType !== "bvLook") {
    if (getCommonVisualizerType() === "kitchen") {
      switch (feature.partId) {
        case "edge_profile":
        case "center_island_edge": {
          const matchCounterTopObject = feature.getParent().getMatchingCounterTop(feature);
          if (matchCounterTopObject.matchingFeature && !matchCounterTopObject.hasSameName) {
            const countertopParent = feature.getParent().getParent().countertop;
            return [{
              from: countertopParent.activeFeature,
              to: matchCounterTopObject.matchingFeature,
            }]
          }
          return []
        }
        default:
          return []
      }
    }
    return []
  }
  const layout = getCurrentLayout();
  const vanityParent = layout.parts[Vanity.id];
  const faucetParent = vanityParent.faucet;
  const sinkParent = vanityParent.sink;
  let nonCompatibleList = [];

  switch (feature.partId) {
    case "vanity_faucet": {
      if (!sinkParent.activeFeature || !sinkParent.activeFeature.matchesMetaForArrayOfConditions(faucetParent.getActiveFeatureConditions(feature))) {
        const nextSink = feature.getSinkToClickFromMatchingSinks(sinkParent.activeFeature);
        if (nextSink) {
          // console.log("sink nextSink", nextSink);
          nonCompatibleList.push({
            from: sinkParent.activeFeature,
            to: nextSink,
          });
          nonCompatibleList = updateNonCompatibleListWithVanity(nextSink, nonCompatibleList);
          return nonCompatibleList
        }
      }
      return []
    }
    case "vanity_sink": {
      const clickedSinkConditions = sinkParent.getActiveFeatureConditions(feature);
      if (!faucetParent.activeFeature || !faucetParent.activeFeature.matchesMetaForArrayOfConditions(clickedSinkConditions)) {
        const navItems = layout.designNavigationItems({part: faucetParent}, [], "", faucetParent.activeFeature);
        const nextFaucet = navItems.find(navItem => {
          return navItem.part.matchesMetaForArrayOfConditions(clickedSinkConditions);
        });
        console.log("nextFaucet", nextFaucet);
        if (nextFaucet) {
          nonCompatibleList.push({
            from: faucetParent.activeFeature,
            to: nextFaucet.part,
          });
        }
      }
      nonCompatibleList = updateNonCompatibleListWithVanity(feature, nonCompatibleList);
      return nonCompatibleList
    }
    case "vanity_cabinet":
    case "vanity_console":
    case "vanity_washstand": {
      const nextSink = getNextSinkOnWashstandOrConsoleChange(feature);
      if (!sinkParent.activeFeature || (nextSink && nextSink.part.dbFeature.id !== sinkParent.activeFeature.dbFeature.id)) {
        if (nextSink) {
          // console.log("sink nextSink", nextSink);
          nonCompatibleList.push({
            from: sinkParent.activeFeature,
            to: nextSink.part,
          });
          const clickedSinkConditions = sinkParent.getActiveFeatureConditions(nextSink.part);
          if (!faucetParent.activeFeature || !faucetParent.activeFeature.matchesMetaForArrayOfConditions(clickedSinkConditions)) {
            const navItems = layout.designNavigationItems({part: faucetParent}, [], "", faucetParent.activeFeature);
            const nextFaucet = navItems.find(navItem => {
              return navItem.part.matchesMetaForArrayOfConditions(clickedSinkConditions);
            });
            console.log("nextFaucet", nextFaucet);
            if (nextFaucet) {
              nonCompatibleList.push({
                from: faucetParent.activeFeature,
                to: nextFaucet.part,
              });
            }
          }
        }
      }
      return nonCompatibleList
    }
    case "shower_arm": {
      const showerArmFeatureGroup = feature.getParent();
      const showerParent = showerArmFeatureGroup.getParent();
      const showerHeadParent = showerParent.showerHead;
      if (!showerHeadParent || !feature.metaData["MountPosition"]) {
        return nonCompatibleList
      }
      const clickedArmConditions = showerArmFeatureGroup.getArrayOfConditions().map(condition => {
        if (condition.propName === "MountPosition") {
          return {
            propName: "MountPosition",
            propValue: feature.metaData["MountPosition"],
          }
        }
        return condition
      })
      if (!showerHeadParent.activeFeature || !showerHeadParent.activeFeature.matchesMetaForArrayOfConditions(clickedArmConditions)) {
        const navItems = layout.designNavigationItems({part: showerHeadParent}, [], "", showerHeadParent.activeFeature);
        const nextFaucet = navItems.find(navItem => {
          return navItem.part.matchesMetaForArrayOfConditions(clickedArmConditions);
        });
        console.log("next shower head", nextFaucet);
        if (nextFaucet) {
          nonCompatibleList.push({
            from: showerHeadParent.activeFeature,
            to: nextFaucet.part,
          });
        }
      }
      return nonCompatibleList
    }
    default:
      return nonCompatibleList
  }
};

/**
 * returns fabricator settings price logic
 * @returns {object}
 */
export const pricingIsLocked = () => {
  const {isBackend, jobId, canSaveQuote} = document.kvConfig;
  const {fabricatorState, userState} = store.getState();
  const {isPhoneNumberValidated} = userState;
  const fabricatorSettings = fabricatorState.settings;

  return {
    showPrice: fabricatorSettings.showPricing && !fabricatorState.hideCheckoutBreakdownCost && !fabricatorState.hidePricesFromUser,
    pricingLocked: fabricatorSettings.leadCapture && !(isBackend && jobId && canSaveQuote) && !isPhoneNumberValidated,
    clickLeadCapture: fabricatorSettings.clickLeadCapture,
    isLixil: isIframe() && fabricatorState.isLixil
  }
}



/**
 * checks features and downloads by name if they are missing
 * @param missingFeatures {array}
 * @param originalPartId {string}
 */
export const getMissingFeaturesAndClickThem = async (missingFeatures = [], originalPartId = "") => {
  if (!missingFeatures.length) {
    return Promise.resolve()
  }
  window.requestInProcess = true;
  loaderEnable();
  const layout = getCurrentLayout();
  const wallParent = layout.parts["Walls"];

  const pageSize = 9999;
  for (let missingFeatureObject of missingFeatures) {
    const {relatedItem, navigationItemName, requestFromBackendName} = missingFeatureObject;
    const dbName = relatedItem.dbName || relatedItem.partName;
    if (relatedItem.additionalPartPartId && wallParent && wallParent.relatedItems.some(relItem => relItem.partId === relatedItem.partId)) {
      const cropResponse = await getBvGroupFeatures(dbName + " Crop", 0, pageSize, [], requestFromBackendName || navigationItemName);
      if (Array.isArray(cropResponse)) {
        relatedItem.setGroupFeatures(cropResponse, pageSize, false, "", null, true, false);
      }
    }
    if (relatedItem.partId !== originalPartId) { // we need to check crop for current wall! but no need to request the wall itself
      const response = await getBvGroupFeatures(dbName, 0, pageSize, [], requestFromBackendName || navigationItemName);
      relatedItem.setGroupFeatures(response, pageSize, false, "", null, true, false);
    }
  }
  for (let missingFeatureObject of missingFeatures) {
    const {relatedItem, navigationItemName, setCurrentFeature, requestFromBackendName} = missingFeatureObject;
    const featureFound = layout.designNavigationItems({part: relatedItem}).find(navItem => {
      return navItem.part.getSplittedFeatureName() === navigationItemName
    });
    if (featureFound) {
      if (setCurrentFeature) {
        relatedItem.activeFeatureBeforeAllWalls = relatedItem.activeFeature;
      }
      featureFound.part.clickFromAllWalls(true)
    }
    if (relatedItem.partId !== originalPartId) {
      if (!relatedItem.alreadyRequestedFeatureNames) {
        relatedItem.alreadyRequestedFeatureNames = [];
      }
      relatedItem.alreadyRequestedFeatureNames.push(requestFromBackendName || navigationItemName);
    }
  }

  window.requestInProcess = false;
  loaderDisable();
  // if (updateCanvas) {
  store.dispatch(setMaterialsCanvasLoading(false)); // fridge enclosure issue on not existing fridge enclosure scene
  store.dispatch(updateCanvasCount());
  // }
  return Promise.resolve()
}

export const getShowMatchRadio = (lookFeature) => {
  if (LOOK_WALLS_ONLY.includes(lookFeature.partId)) {
    return true
  }
  switch (getCommonVisualizerType()) {
    case "kitchen":
    case "laundryroom": {
      if (EDGE_GROUP.includes(lookFeature.partId)) {
        if (lookFeature.partId === "edge_profile") { // back countertop
          const layout = getCurrentLayout();
          return layout.parts["CenterIsland"] && layout.parts["CenterIsland"].countertop
            && !layout.parts["CenterIsland"].countertop.disabled
        }
        return true
      }
      if (COUNTERTOP_GROUP.includes(lookFeature.partId) && !CountertopSwitchers.checkForTileBacksplash(lookFeature)) {
        return true
      }
      return CABINET_GROUP.includes(lookFeature.partId)
    }
    case "bathroom":
      // if (CABINET_GROUP_BATHROOM.includes(lookFeature.partId)) {
      //   return lookFeature.partId !== "vanity_cabinet" || (lookFeature.metaData["MatchingFeature"]
      //     && lookFeature.metaData["MatchingFeature"].includes(METADATA.NO))
      // isFeatureEnabled(lookActiveFeature, "quotingTool") ??
      // }
      return COUNTERTOP_GROUP_BATHROOM.includes(lookFeature.partId)
        || HANDLES_GROUP_BATHROOM.includes(lookFeature.partId)
        || SHOWER_FLOOR_GROUP_BATHROOM.includes(lookFeature.partId)
    default:
      return false
  }
}

/**
 * returns fabricator settings price logic
 * @param lookFeature {featureInterface}
 * @returns {allWallsLogicInterface} object
 */
export const getApplyToLogic = (lookFeature) => {
  if (!lookFeature) {
    return null
  }
  if (LOOK_WALLS_ONLY.includes(lookFeature.partId)) {
    const {lookState} = store.getState();
    return {
      type: "walls",
      translateId: "look.allWalls",
      setApplyToFunction: setLookWallsApplyTo,
      applyToArrayAll: LOOK_WALLS_ONLY,
      currentApplyToArray: lookState.lookWallsApplyTo,
    }
  }
  switch (getCommonVisualizerType()) {
    case "kitchen":
    case "laundryroom": {
      if (CABINET_GROUP.includes(lookFeature.partId)) {
        const {navigationState} = store.getState();
        return {
          type: "cabinets",
          translateId: "look.allCabinets",
          setApplyToFunction: setCabinetsApplyTo,
          applyToArrayAll: CABINET_GROUP,
          currentApplyToArray: navigationState.cabinetsApplyTo,
        }
      } else if (COUNTERTOP_GROUP.includes(lookFeature.partId)) {
        const {navigationState} = store.getState();
        return {
          type: "countertops",
          translateId: "look.allCountertops",
          setApplyToFunction: setCountertopsApplyTo,
          applyToArrayAll: COUNTERTOP_GROUP,
          currentApplyToArray: navigationState.countertopsApplyToArray,
        }
      } else if (EDGE_GROUP.includes(lookFeature.partId)) {
        const {navigationState} = store.getState();
        return {
          type: "edges",
          translateId: "look.allCountertops",
          setApplyToFunction: setEdgesApplyTo,
          applyToArrayAll: EDGE_GROUP,
          currentApplyToArray: navigationState.edgesApplyTo,
        }
      }
      break;
    }
    case "bathroom": {
      if (CABINET_GROUP_BATHROOM.includes(lookFeature.partId) && (document.kvConfig.visualizerType !== "bvLook")) {
        const {navigationState} = store.getState();
        return {
          type: "cabinets",
          translateId: "look.allCabinets",
          setApplyToFunction: setCabinetsApplyToBathroom,
          applyToArrayAll: CABINET_GROUP,
          currentApplyToArray: navigationState.cabinetsApplyToBathroom,
        }
      } else if (COUNTERTOP_GROUP_BATHROOM.includes(lookFeature.partId)) {
        const {navigationState} = store.getState();
        return {
          type: "countertops",
          translateId: "look.allCountertops",
          setApplyToFunction: setCountertopsApplyToBathroom,
          applyToArrayAll: COUNTERTOP_GROUP_BATHROOM,
          currentApplyToArray: navigationState.countertopsApplyToArrayBathroom,
        }
      } else if (HANDLES_GROUP_BATHROOM.includes(lookFeature.partId)) {
        const {navigationState} = store.getState();
        return {
          type: "handles",
          translateId: "look.allCountertops",
          setApplyToFunction: setApplyToCommon,
          applyToArrayAll: HANDLES_GROUP_BATHROOM,
          currentApplyToArray: navigationState.handlesApplyToBathroom,
        }
      } else if (SHOWER_FLOOR_GROUP_BATHROOM.includes(lookFeature.partId)) {
        const {navigationState} = store.getState();
        return {
          type: "showerFloor",
          translateId: "look.allCountertops",
          setApplyToFunction: setApplyToCommon,
          applyToArrayAll: SHOWER_FLOOR_GROUP_BATHROOM,
          currentApplyToArray: navigationState.showerFloorApplyToBathroom,
        }
      }
      break;
    }
  }

  return null
}

/**
 * returns fabricator settings price logic
 * @param wallFeature {featureInterface}
 * @param applyToLogic {allWallsLogicInterface}
 * @param setCurrentFeature {boolean}
 * @param propsFeatureIsLocked {boolean}
 */
export const clickOnSimilarFeatures = async (wallFeature,
                                             applyToLogic,
                                             setCurrentFeature = false,
                                             propsFeatureIsLocked) => {
  const layout = getCurrentLayout();
  let {type, applyToArrayAll} = applyToLogic;

  const {navigationState, fabricatorState} = store.getState();
  if ((type === "countertops" && !navigationState.useFeaturesLightRequest.countertops)
    || (type === "cabinets" && !navigationState.useFeaturesLightRequest.cabinets)) {
    if (setCurrentFeature && !fabricatorState.isSolidSurface) {
      store.dispatch(applyToLogic.setApplyToFunction([], true, type));
      return Promise.resolve()
    }
  }

  if (type === "countertops") {
    const featureIsLocked = propsFeatureIsLocked ?? getFeatureIsLocked(wallFeature);
    return CountertopSwitchers.applyAllCountertops(wallFeature, !featureIsLocked, applyToArrayAll, setCurrentFeature);
  } else if (type === "cabinets") {
    const featureIsLocked = propsFeatureIsLocked ?? getFeatureIsLocked(wallFeature);
    return CabinetSwitchers.applyClickTo(wallFeature, !featureIsLocked, applyToArrayAll, setCurrentFeature)
  } else {
    const navigationItemName = wallFeature.getSplittedFeatureName();
    const requestFromBackendName = layout.isNewLayout ? wallFeature.getCountertopGroupsSplittedFeatureName() : wallFeature.getSplittedFeatureName();
    // we are looking and matching splitted feature name, because it includes filters, but we request original sharedFeatureName
    let missingFeatures = [];
    applyToArrayAll.forEach(wallPartId => {
      const subPart = layout.getSubPartByPartId(wallPartId);
      if (!subPart || (subPart.part.partId === wallFeature.partId)) {
        return null
      }
      const featureFound = layout.designNavigationItems(subPart).find(navItem => {
        return navItem.part.getSplittedFeatureName() === navigationItemName
      });
      if (featureFound) {
        if (setCurrentFeature) {
          subPart.part.activeFeatureBeforeAllWalls = subPart.part.activeFeature;
        }
        featureFound.part.clickFromAllWalls(true)
      } else if ((type !== "edges") && !subPart.part.getRealFeaturesReceivedProperty()
        && (!subPart.part.alreadyRequestedFeatureNames || !subPart.part.alreadyRequestedFeatureNames.includes(requestFromBackendName))) {
        // @param missingFeaturesArray {featureGroupInterface}
        // @param navigationItemName {string}
        // @param setCurrentFeature {boolean}
        missingFeatures.push({relatedItem: subPart.part, navigationItemName, setCurrentFeature, requestFromBackendName})
      }
    });
    if (missingFeatures.length) {
      missingFeatures.push({relatedItem: wallFeature.getParent(), navigationItemName, setCurrentFeature, requestFromBackendName})
      // we need to check crop for current wall! but no need to request the wall itself
      await getMissingFeaturesAndClickThem(missingFeatures,wallFeature.partId)
    }
    return Promise.resolve()
  }
}

/**
 * returns fabricator settings price logic
 * @param applyToArray {array<string>}
 * @param onlyForOneFeatureGroup {object}
 */
export const setActiveFeaturesBeforeAllWalls = (applyToArray = [], onlyForOneFeatureGroup = null) => {
  if (onlyForOneFeatureGroup && onlyForOneFeatureGroup.activeFeature) {
    onlyForOneFeatureGroup.activeFeatureBeforeAllWalls = onlyForOneFeatureGroup.activeFeature;
    return
  }
  const layout = getCurrentLayout();
  applyToArray.forEach(partId => {
    const featureGroup = layout.getFeatureGroupByPartId(partId);
    if (featureGroup && featureGroup.activeFeature) {
      featureGroup.activeFeatureBeforeAllWalls = featureGroup.activeFeature;
    }
  })
}

export const requestAfterRoomChange = async (layout) => {
  let promises = [];
  const layoutName = layout.getCurrentLayoutAbbreviation();
  layout.getFeatures().forEach(parent => {
    if (!Array.isArray(parent.relatedItems) || !parent.relatedItems.length) {
      return
    }
    parent.relatedItems.forEach(featureGroup => {
      if (featureGroup.allFeaturesReceived
        && featureGroup.nextFeaturesPageToLoadArray
        && featureGroup.nextFeaturesPageToLoadArray[layoutName]
        && !featureGroup.nextFeaturesPageToLoadArray[layoutName].page) {
        promises.push(getAdditionalFeaturesOnScroll(featureGroup))
      }
    })
  });
  if (layout.visualizerType === "kvScene") {
    //here we need to receive for current preset all cabinets since if in the first 6k response they are missing -
    // we have to get them manually
    CabinetSwitchers.getCurrentActiveFeatureAllFeatures(); // no await here, let it run on background
  }
  return Promise.all(promises)
}


/**
 * returns fabricator settings price logic
 * @param roomPreset {object}
 * @param loadedPresets {array}
 */
export const applyNewPreset = async (roomPreset, loadedPresets) => {
  const layout = getCurrentLayout();
  if (loadedPresets.includes(roomPreset.id)) {
    layout.setActiveFeaturesFromObject(roomPreset, false, false, true, false);
    await requestAfterRoomChange(layout);
  } else {
    await layout.setItemsFromBvState(roomPreset); // requestAfterRoomChange inside
  }
  return Promise.resolve()
}

export const isRoomLayoutsVisible = () => {
  return Config.isVisualizerManagement() || Config.isDevMode()
}

/**
 * returns feature group current items quantity depending on layer positions
 * @param lookActiveFeature {featureInterface}
 * @param featureGroup {featureGroupInterface}
 * @param wizardGroup {wizardGroupInterface}
 * @return number {number}
 */
export const getFeatureGroupFeaturesQuantity = (lookActiveFeature, featureGroup = null, wizardGroup = null) => {
  if (wizardGroup && wizardGroup.useCustomDefaultQuantity && wizardGroup.defaultWizardQuantity) {
    return +wizardGroup.defaultWizardQuantity
  }
  let featureQuantity = 1;
  if (!featureGroup && lookActiveFeature && lookActiveFeature.getParent) {
    featureGroup = lookActiveFeature.getParent()
  }
  if (featureGroup) {
    const currentActiveFeature = lookActiveFeature || featureGroup.activeFeature || featureGroup.activeNotInVisualizerFeature
    if (currentActiveFeature && currentActiveFeature.dbFeature.defaultQuantity
      && (currentActiveFeature.dbFeature.defaultQuantity !== 1
        || (currentActiveFeature.partId === "vanity_cabinet"
          || (currentActiveFeature.partId === "vanity_sink"
            && Array.isArray(currentActiveFeature.metaData["MountType"])
            && currentActiveFeature.metaData["MountType"].includes("ST"))))) {
      // for cabinets and pedestal sinks we use default quantity 1 if set
      featureQuantity = currentActiveFeature.dbFeature.defaultQuantity;
    } else if (featureGroup.layerPositions && !featureGroup.disabled && (!currentActiveFeature || !currentActiveFeature.notAvailableInVisualizer)) {
      // if feature is not available in visualizer > set at least 1 instead of 0 (missing sink in the cart in solid surface wizard issue)
      featureQuantity = Object.keys(featureGroup.layerPositions)
        .filter(position => !!featureGroup.layerPositions[position]).length
    }
  }
  return featureQuantity
}
